import React, { useState } from "react";
import "./Container.css";

import { Card } from "grommet";
import { CardHeader } from "grommet";
import { CardBody } from "grommet";
import { CardFooter } from "grommet";
import { Button } from "grommet";
import { Favorite, Link, LinkDown } from "grommet-icons";

const portMap = {
  "Gills Bay": "1",
  "St. Margaret's Hope Ferry Terminal": "2",
  Oban: "3",
  Craignure: "4",
};

function getPortName(portId) {
  return Object.keys(portMap).find((key) => portMap[key] === portId);
}

function spliceString(startDay) {
  const year = startDay.slice(0, 4);
  const month = startDay.slice(5, 7);
  const day = startDay.slice(8, 10);
  const newDate = day + "/" + month + "/" + year;
  return newDate;
}

const GetAllButton = (props) => {
  const [trips, setTrips] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = useState("");

  const handleClick = async () => {
    setIsLoading(true);

    try {
      const response = await fetch(
        "https://ferry-backend.vercel.app/api/trips",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      ).then((response) => response.json());

      const filteredResults = response.filter((result) => {
        const resultDate = new Date(result.tripDate);
        resultDate.toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
        if (
          result.portFromId === portMap[props.depPort] &&
          result.portToId === portMap[props.arrPort] &&
          new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }).format(resultDate) ===
            new Intl.DateTimeFormat("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            }).format(props.date)
        ) {
          return true;
        }
        return false;
      });
      console.log(filteredResults);

      setTrips(filteredResults);
    } catch (err) {
      setErr("No trips found");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddToFavorites = async (tripId) => {
    await fetch("https://ferry-backend.vercel.app/api/addToFavoriteTrips", {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: {
        userId: props.userData._id,
        tripId: tripId,
      },
    }).then((response) => response.json());
  };

  const handleDeleteFromFavorites = async (tripId) => {
    await fetch("https://ferry-backend.vercel.app/api/deleteFromFavorites", {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: {
        userId: props.userData._id,
        tripId: tripId,
      },
    }).then((response) => response.json());
  };

  return (
    <div className="trips-container">
      {err && <h2>{err}</h2>}
      <button className="button-getall" onClick={handleClick}>
        Get routes
      </button>
      {isLoading && <h2>Loading...</h2>}

      {trips &&
        trips.map((trip) => (
          <div className="item-container" key={trip._id}>
            <div className="background-blur">
              <br />

              <Card
                height="fit"
                width="50%"
                background="light-1"
                display="flex"
                margin="auto"
                elevation="10%"
              >
                <CardHeader pad="medium">
                  {spliceString(trip.tripDate)}
                </CardHeader>

                <CardBody pad="medium" align="center">
                  {getPortName(trip.portFromId)} to {getPortName(trip.portToId)}
                </CardBody>

                <CardBody pad="medium" align="center">
                  {trip.hourStart} <LinkDown /> {trip.hourEnd}
                </CardBody>

                <CardBody pad="medium" align="center">
                  Trip Duration: {parseInt(trip.durationMinutes)} minutes <br />
                </CardBody>

                <CardFooter background="light-3" alignContent="center">
                  <Button
                    onClick={() =>
                      props.userData.favoriteTrips.includes(trip._id)
                        ? handleDeleteFromFavorites(trip._id)
                        : handleAddToFavorites(trip._id)
                    }
                    icon={<Favorite color="red" />}
                    hoverIndicator
                  />
                  <a
                    href="https://www.pentlandbookings.co.uk/booking/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" "}
                    <Button icon={<Link color="plain" />} hoverIndicator />
                  </a>
                </CardFooter>
              </Card>
            </div>
          </div>
        ))}
    </div>
  );
};

export default GetAllButton;
